<ion-header class="ion-no-border" mode="ios">
  <ion-toolbar class="ion-no-padding">
    <ion-button class="ion-no-padding" slot="start" fill="clear" size="small" (click)="closeOrGoBack()">
      <ion-icon slot="icon-only" name="chevron-back"></ion-icon>
    </ion-button>
    <ion-title class="fs-18 font-medium">{{ 'pages.insert.form.subtaskModal.title' | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-no-padding">
  <ui-article-select-list
    *ngIf="!isDirectArticleSelection"
    [categories]="categories"
    [initialCategory]="startAtArticles ? categories[0] : undefined"
    [initialItem]="startAtArticles && categories.length > 0 ? categories[0].items[0] : undefined"
    [showAmounts]="true"
    [showFilters]="true"
    [filterProperty]="filterProperty"
    [filtersConfig]="filterConfig"
    (articleSelected)="onArticleSelected($event)"
    (itemSelected)="onItemSelected($event)"
    (categorySelected)="onCategorySelected($event)"
  >
  </ui-article-select-list>

  <ion-list *ngIf="isDirectArticleSelection" class="direct-article-list" data-cy="Direct articles list">
    <ion-item
      *ngFor="let directArticle of directArticles"
      [button]="true"
      class="direct-article-item"
      data-cy="Direct article item"
      (click)="onDirectArticleSelected(directArticle)"
    >
      <ion-icon name="pricetag" class="item-icon"></ion-icon>
      <ion-label>
        <h2 class="font-medium">{{ directArticle.article.name }}</h2>
        <p>{{ directArticle.item.name }}</p>
      </ion-label>
      <ion-icon *ngIf="isDirectArticleSelected(directArticle)" name="checkmark-circle" color="success"></ion-icon>
      <ion-icon *ngIf="!isDirectArticleSelected(directArticle)" name="ellipse-outline" color="medium"></ion-icon>
    </ion-item>
  </ion-list>
</ion-content>

<ion-footer class="ion-no-border" mode="ios">
  <ion-toolbar>
    <ion-button color="primary" expand="block" fill="solid" class="w-full" data-cy="Accept budget item" (click)="confirm()">
      {{ 'quote.filters.accept' | translate }}
    </ion-button>
  </ion-toolbar>
</ion-footer>
